/* eslint-disable */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

//Style
import styles from "./taskViewTableData.module.css"

// @mui material components
import Icon from "@mui/material/Icon";
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';
import AssignmentLateRoundedIcon from '@mui/icons-material/AssignmentLateRounded';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDProgress from "components/MDProgress";
import MDBadge from "components/MDBadge";

// Images
import LogoAsana from "assets/images/small-logos/logo-asana.svg";
import logoGithub from "assets/images/small-logos/github.svg";
import logoAtlassian from "assets/images/small-logos/logo-atlassian.svg";
import logoSlack from "assets/images/small-logos/logo-slack.svg";
import logoSpotify from "assets/images/small-logos/logo-spotify.svg";
import logoInvesion from "assets/images/small-logos/logo-invision.svg";
import { Assignment, AssignmentRounded, ErrorRounded } from "@mui/icons-material";
import { Box, Menu, MenuItem, Tooltip } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Navigate, Route, useNavigate } from "react-router-dom";


export default function data(tasksData, updateTasksData) {

  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVibrating, setIsVibrating] = useState(false);
  const openedTaskID = localStorage.getItem("lastOpenedTask");


  const Project = ({ image, name, taskID}) => {
    const rowRef = useRef(null);
    let vibrate = false;

    useEffect(() => {

      // console.log("-----------------------");
      // console.log("Project taskID");
      // console.log(typeof(taskID));
      // console.log(taskID);

      // console.log("Project openedTaskID");
      // console.log(typeof(Number(openedTaskID)));
      // console.log(Number(openedTaskID));

      // console.log("Project rowRef.current");
      // console.log(rowRef.current);
      // console.log("-----------------------");
      
      if (!isScrolled && Number(openedTaskID) === taskID && rowRef.current) {
        console.log("Skrolowanie działa");
        console.log("rowRef.current?");
        console.log(rowRef.current);
        rowRef.current?.scrollIntoView({ behavior: "instant", block: "center" });
        setIsScrolled(true);

        // handleVibration();
        setIsVibrating(true);
        vibrate = true;

        // Wibracja przez 3 sekundy
        setTimeout(() => {
          setIsVibrating(false);
        }, 3000);

      }
    }, [taskID]);

    const handleVibration = () => {
      setIsVibrating(true);
    };
    
    const handleEndVibration = () => {
      setIsVibrating(false);
    };

    return(
      <MDBox ref={rowRef} display="flex" alignItems="center" lineHeight={1} 
        onClick={() => {
          sessionStorage.setItem("lastOpenedTask", taskID);
          localStorage.setItem("lastOpenedTask", taskID);
          navigate("/task-view", { state: { taskID: taskID } }); 
        }}
        // onBlur={handleEndVibration}
        // className={isVibrating ? "vibrate" : ""}
        // className={isVibrating && styles.vibrate}
        // className={ Number(openedTaskID) === taskID ? `${styles.vibrate}` : ""}
        className={ Number(openedTaskID) === taskID ? styles.blink : ""}
        sx={{
          cursor:"pointer",
          transition: "background-color 0.3s, box-shadow 0.3s", // Dodaj płynne przejście dla zmiany koloru tła
          borderRadius: "8px",
          padding: "4px",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.05)", // Delikatnie ciemniejsze tło po najechaniu myszką
          },
        }} >
        {/* <MDAvatar src={image} name={name} size="sm" variant="rounded" /> */}
        <AssignmentRounded fontSize="medium" /> 
        <MDTypography display="block" variant="button" fontWeight="medium" ml={1} lineHeight={1}>
          {name}
        </MDTypography>
      </MDBox>
    );
    
  };

  const Progress = ({ color, value }) => (
    <MDBox display="flex" alignItems="center">
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {value}%
      </MDTypography>
      <MDBox ml={0.5} width="9rem">
        <MDProgress variant="gradient" color={color} value={value} />
      </MDBox>
    </MDBox>
  );

  const formatTimeToMinutes = (time) => {
    return time !== null ? time.slice(0, 16) : null; // Obcina do pierwszych 16 znaków
  };

  const calculateTimeDifference = (creationTime) => {
    const creationDate = new Date(creationTime);
    const currentDate = new Date();
  
    // Oblicz różnicę czasu w milisekundach
    const timeDifference = currentDate - creationDate;
  
    // Oblicz liczbę dni, godzin i minut
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
  
    if(days === 0 && hours !== 0){
      return `${hours} godz`;
    } else if(days === 0 && hours === 0){
      return `${minutes} min`;
    } else {
      return `${days} dni i ${hours} godz`;
    }

  };

  const [selectedTask, setSelectedTask] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleTaskOptionsOpen = (task, event) => {
    setSelectedTask(task);
    setAnchorEl(event.currentTarget);
  };
  
  const handleTaskOptionsClose = () => {
    setSelectedTask(null);
    setAnchorEl(null);
  };

  const handleUpdateTasksData = () => {
    updateTasksData(prevValue => prevValue + 1);
  }


  const handleOpenTask = async () => {
    navigate("/task-view", { state: { taskID: selectedTask.id } });
  };

  const handleReopenTask = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/reopenTaskById", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          reopenTaskID: selectedTask.id
        }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("React Response SUCCESS: ", data.message);
        handleUpdateTasksData();
      } else {
        console.error("React Response NOT SUCCESS: ", data.message);
      }
    } catch (error) {
      console.error("Błąd podczas wysyłania żądania:", error);
    }
  };

  const handleCancelTask = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/cancelTaskById", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          cancelTaskID: selectedTask.id
        }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("React Response SUCCESS: ", data.message);
        handleUpdateTasksData();
      } else {
        console.error("React Response NOT SUCCESS: ", data.message);
      }
    } catch (error) {
      console.error("Błąd podczas wysyłania żądania:", error);
    }
  };

  const handleCloseTask = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/closeTaskById", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          closeTaskID: selectedTask.id
        }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("React Response SUCCESS: ", data.message);
        handleUpdateTasksData();
      } else {
        console.error("React Response NOT SUCCESS: ", data.message);
      }
    } catch (error) {
      console.error("Błąd podczas wysyłania żądania:", error);
    }
  };


  const renderMenu = (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(selectedTask)}
      onClose={handleTaskOptionsClose}
    >
      <MenuItem onClick={() => {handleTaskOptionsClose(); handleOpenTask();}}>Podgląd</MenuItem>
      <MenuItem onClick={() => {handleTaskOptionsClose(); handleReopenTask();}}>Wznów realizację</MenuItem>
      <MenuItem onClick={() => {handleTaskOptionsClose(); handleCancelTask();}}>Anuluj</MenuItem>
      <MenuItem onClick={() => {handleTaskOptionsClose(); handleCloseTask();}}>Zamknij</MenuItem>
    </Menu>
  );


  const columns = [
    { field: 'id', headerName: 'ID', width: 60, 
      renderCell: (params)=>(
        <MDTypography component="a" variant="caption" color="text" fontWeight="medium" fontSize={14} >
          {params.value}
        </MDTypography>
      )
    },
    { field: 'project', headerName: 'Zadanie', width: 500,
      renderCell: (params) => (
        <Box display="flex" alignItems="center">
          <Project image={LogoAsana} name={params.value.slice(0, 48)} taskID={params.row.id} />
        </Box>
      )
    },
    { field: 'processTime', headerName: 'Od stworzenia', width: 130, align: 'center', headerAlign: 'center',
      renderCell: (params) => (
        <MDTypography component="a" variant="caption" color="text" fontWeight="medium">
          {calculateTimeDifference(params.value)}
        </MDTypography>
      )
    },
    { field: 'whoCreatedTask', headerName: 'Dodał', width: 130, align: 'center', headerAlign: 'center',
      renderCell: (params) => (
        <MDTypography component="a" variant="caption" color="text" fontWeight="medium">
          {params.value}
        </MDTypography>
      )
    },
    { field: 'status', headerName: 'Status', width: 100, align: 'center', headerAlign: 'center',
      renderCell: (params) => (
        <MDBadge badgeContent={params.value}
          color={
            params.value === "nowe" ? "info" : 
            params.value === "realizowane" ? "success" : 
            params.value === "anulowane" ? "primary" : 
            params.value === "zamknięte" ? "dark" : "light"
          } 
          variant="gradient" size="sm" />
      )
    },
    { field: 'priority', headerName: 'Priorytet', width: 80, align: 'center', headerAlign: 'center',
      renderCell: (params) => (
        <Tooltip title="Zadanie ma priorytet">
          <MDTypography component="a" variant="subtitle1" color="warning" fontWeight="medium">
            {params.value === "hight" ? <ErrorRounded /> : null}
          </MDTypography>
        </Tooltip>
      )
    },
    { field: 'creationTime', headerName: 'Stworzono', width: 130, align: 'center', headerAlign: 'center',
      renderCell: (params) => (
      <MDTypography component="a" variant="caption" color="text" fontWeight="medium">
         {new Date(params.value).toISOString().split("T")[0]}
      </MDTypography>
      )
    },
    { field: 'timeToDo', headerName: 'Do kiedy', width: 130, align: 'center', headerAlign: 'center',
      renderCell: (params) => (
        <MDTypography component="a" variant="caption" color="text" fontWeight="medium">
          {formatTimeToMinutes(params.value)}
        </MDTypography>
      )
    },
  ];

  
  const rows = tasksData.map((task) => ({
    id: task.id,
    project: task.title,
    processTime: task.creation_time,
    whoCreatedTask: task.first_name+" "+task.last_name,
    status: task.status,
    priority: task.priority,
    creationTime: task.creation_time,
    timeToDo: task.time_to_do,
  }));

  return {
    columns,
    rows

    // columns: [
    //   // { Header: "ID", accessor: "id", width: "1%", align: "left" },
    //   // { Header: "Zadanie", accessor: "project", width: "50%", align: "left" },
    //   // { Header: "Od Stworzenia", accessor: "processTime", align: "center", width: "5%" },
    //   // { Header: "Dodał", accessor: "whoCreatedTask", align: "center", width: "5%" },
    //   // { Header: "status", accessor: "status", align: "center", width: "5%" },
    //   // { Header: "priorytet", accessor: "priority", align: "center", width: "5%" },
    //   // { Header: "Stworzono", accessor: "creationTime", align: "center", width: "5%" },
    //   // // { Header: "Czas wykonywania", accessor: "completion", align: "center", width: "5%" },
    //   // { Header: "Do kiedy", accessor: "timeToDo", align: "center", width: "5%" },
    //   // // { Header: "Opcje", accessor: "option", align: "center", width: "5%" },
    //   { field: 'id', headerName: 'ID', width: 60 },
    //   { field: 'project', headerName: 'Zadanie', width: 500 },
    //   { field: 'processTime', headerName: 'Od stworzenia', width: 130 },
    //   { field: 'whoCreatedTask', headerName: 'Dodał', width: 130 },
    //   { field: 'status', headerName: 'Status', width: 100 },
    //   { field: 'priority', headerName: 'Priorytet', width: 60 },
    //   { field: 'creationTime', headerName: 'Stworzono', width: 130 },
    //   { field: 'timeToDo', headerName: 'Do kiedy', width: 130 },
    // ],

    // rows: tasksData.map(task => ({
    //   id: task.id,
    //   project: <Project image={LogoAsana} name={task.title.slice(0,48)} taskID={task.id}/>,
    //   timeToDo: (
    //     <MDTypography component="a" variant="caption" color="text" fontWeight="medium">
    //       {formatTimeToMinutes(task.time_to_do)}
    //     </MDTypography>
    //   ),
    //   whoCreatedTask: (
    //     <MDTypography component="a" variant="caption" color="text" fontWeight="medium">
    //       {task.first_name+" "+task.last_name}
    //     </MDTypography>
    //   ),
    //   status: (
    //     <MDBadge badgeContent={task.status}
    //       color={task.status === "nowe" ? "info" : 
    //         task.status === "realizowane" ? "success" : 
    //         task.status === "anulowane" ? "primary" : 
    //         task.status === "zamknięte" ? "dark" : "light"} 
    //       variant="gradient" size="sm" />
    //   ),
    //   priority: (
    //     <Tooltip title="Zadanie ma priorytet">
    //       <MDTypography component="a" variant="subtitle1" color="warning" fontWeight="medium">
    //         {task.priority === "hight" ? <ErrorRounded /> : null}
    //       </MDTypography>
    //     </Tooltip>
    //   ),
    //   creationTime: (
    //     <MDTypography component="a" variant="caption" color="text" fontWeight="medium">
    //       {/* {formatTimeToMinutes(task.creation_time)} */}
    //       {new Date(task.creation_time).toISOString().split("T")[0]}
    //     </MDTypography>
    //   ),
    //   // completion: <Progress color="info" value={60%} />,
    //   processTime: (
    //     <MDTypography component="a" variant="caption" color="text" fontWeight="medium">
    //       {calculateTimeDifference(task.creation_time)}
    //     </MDTypography>
    //   ),
    //   option: (
    //     <MDTypography component="a" color="text" style={{ cursor: "pointer" }}>
    //       <Icon onClick={(event) => handleTaskOptionsOpen(task, event)}>more_vert</Icon> 
    //       {selectedTask === task && renderMenu}
    //     </MDTypography>
    //   ),
    // })),



  };
}
